<template>
  <div v-cloak class="sliding">
    <transition name="fade">
      <div
        v-if="show"
        class="sliding-mask"
        @click.stop="close"
        @touchmove.stop.prevent
      />
    </transition>
    <transition name="slide">
      <article v-show="show" class="slide-pop">
        <span class="close" @click.stop="close">
          <i v-if="iconfont" :class="`iconfont ${iconfont}`" />
          <i v-else class="iconfont icon-close_circle_line" />
        </span>
        <div v-if="title" class="slide-hd after-bd-b">
          {{ title }}
        </div>
        <div
          class="slide-bd"
          :class="{ 'slide-notitle': !title }"
          :style="overStyle"
        >
          <slot />
        </div>
      </article>
    </transition>
  </div>
</template>

<script>
import {
  addClass,
  removeClass,
  prefixStyle,
  stopBodyScroll
} from 'common/js/dom'

let transform = prefixStyle('transform')
const POPOVER_CLASSNAME = 'popover'

export default {
  name: 'Sliding',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    overHeight: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    iconfont: {
      type: String,
      default: 'icon-close_circle_line'
    }
  },
  data () {
    return {}
  },
  computed: {
    overStyle () {
      let style = {}
      if (!this.overHeight) {
        style = {
          'overflow-y': 'auto'
        }
      }
      return style
    }
  },
  watch: {
    show: function (newVisble) {
      stopBodyScroll(newVisble)
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    _getScrollTop () {
      return (
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop
      )
    },
    _setScrollTop (scrollTop) {
      document.documentElement.scrollTop = scrollTop
      document.body.scrollTop = scrollTop
    }
  }
}
</script>

<style lang="postcss">
.popover {
  overflow: hidden;
  height: 100%;
}

.sliding {
  position: fixed;
  z-index: 999;
}

.sliding-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backface-visibility: hidden;
}

.slide-pop {
  z-index: 1001;
  position: fixed;
  top: 10%;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  backface-visibility: hidden;
  .close {
    z-index: 1001;
    position: absolute;
    right: 0;
    top: 0;
    width: 45px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    -webkit-tap-highlight-color: transparent;
    font-size: 16px;
    & i {
      font-size: 18px;
      color: #ccc;
    }
  }
  .slide-hd {
    z-index: 1;
    left: 0;
    top: 0;
    position: absolute;
    width: 100%;
    height: 45px;
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    line-height: 45px;
  }
  .slide-bd {
    height: 100%;
    border-top: 45px solid #fff;
    font-size: 13px;
    line-height: 20px;

    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      display: none;
      background-color: transparent;
    }
  }
  .slide-notitle {
    border-top: 0;
  }
}

.slide-enter-active {
  animation: fadeInUp 0.3s;
}

.slide-leave-active {
  animation: fadeInDown 0.3s;
}

.fade-enter-active {
  animation: fadeIn 0.5s;
}

.fade-leave-active {
  animation: fadeOut 0.5s;
}
</style>